<template>
    <div
        class="select"
        :class="{'validate-error': !validateResult,readonly,invisible,focus:focusFlag}"
        @mousedown.stop
        @dblclick="dblclickHandle"
        @click="clickHandle"
    >
        <div v-if="readonly || invisible" class="readonly-text" v-html="text"></div>
        <div v-else class="select-container" v-on:click="showItems($event)">
            <div class="text" :name="field" v-if="text">
                <div class="text-ellipsis" :title="text" v-html="text"></div>
            </div>
            <div class="placeholder" v-else>{{placeholder}}</div>
            <div class="icon">
                <arrow-down v-bind="{color:'#666666',width:'8px',height:'8px'}" />
            </div>
        </div>
    </div>
</template>
<script>
import Gikam from "../../../core/gikam-core";
import jQuery from "jquery";
import Vue from "vue";
export default {
    props: {
        options: Object,
        rowIndex: Number,
        propValue: String,
        propInvisible: {
            type: Boolean,
            default: false
        },
        propReadonly: {
            type: Boolean,
            default: void 0
        },
    },

    data() {
        return {
            selectPicker: void 0,
            validateResult: true,
            readonly: Gikam.isNotEmpty(this.propReadonly) ? this.propReadonly : this.options.readonly,
            items: this.options.items || [],
            placeholder: this.options.placeholder,
            value: this.getDefaultValue(),
            field: this.options.field,
            maxHeight: 200,
            invisible: this.propInvisible,
            focusFlag: false
        };
    },

    mounted() {
        this.$emit("rendered", this.field, this.value, this.rowIndex);
    },

    watch: {
        value(val, oldValue) {
            this.$emit(
                "change",
                this.field,
                this.value,
                this.rowIndex,
                oldValue,
                this.text
            );
        },

        propValue(val) {
            this.value = val;
        },

        invisible(bool) {
            if (bool && Gikam.selectPicker) {
                this.cleanSelectPicker();
            }
            if (!bool) {
                setTimeout(() => {
                    Gikam.jQuery(".select.focus .select-container").click();
                });
            }
        }
    },

    computed: {
        text() {
            return this.getSelectText(this.value);
        }
    },

    methods: {
        getSelectText(val) {
            let text;
            Gikam.each(this.items, function() {
                if (this.value + "" === val + "") {
                    text = this.text;
                    return false;
                }
            });
            return text;
        },

        cleanSelectPicker() {
            jQuery(Gikam.selectPicker.$el).remove();
            Gikam.selectPicker.$destroy();
            Gikam.selectPicker = null;
            jQuery(".select.active").removeClass("active");
        },

        clean() {
            this.items.length = 0;
            if (Gikam.isNotEmpty(this.value)) {
                this.$emit("change", this.field, null);
            }
            this.value = null;
        },

        showItems(e) {
            e.stopPropagation();
            if (Gikam.selectPicker) {
                this.cleanSelectPicker();
                return;
            }
            let _this = this;
            let $select = jQuery(this.$el.querySelector(".select-container"));
            $select.parent().addClass("active");

            const mountedDom = document.createElement("div");
            document.body.appendChild(mountedDom);

            const selectHandle = function(e) {
                e.stopPropagation();
                _this.value = e.currentTarget.getAttribute("value");
                _this.cleanSelectPicker();
            };

            let timeoutSearch = null;
            const inputHandle = function(e) {
                e.stopPropagation();
                const _val = e.target.value;
                if (Gikam.isEmpty(_val)) {
                    clearTimeout(timeoutSearch);
                    Gikam.selectPicker.lists = _this.items;
                    Gikam.selectPicker.value = "";
                } else {
                    Gikam.selectPicker.value = _val;
                    if (timeoutSearch) {
                        clearTimeout(timeoutSearch);
                    }
                    timeoutSearch = setTimeout(function() {
                        Gikam.selectPicker.lists = _this.items.filter(function(
                            item
                        ) {
                            return ~item.text.indexOf(_val);
                        });
                    }, 300);
                }
            };

            const selectTop = $select.offset().top;

            const pickerHeight =
                this.items.length * 32 > this.maxHeight
                    ? this.maxHeight
                    : this.items.length * 32;

            const $top =
                selectTop + this.maxHeight > jQuery(window).height()
                    ? selectTop - pickerHeight - 4
                    : selectTop + $select.outerHeight();

            const $left = $select.offset().left;
            const $width = $select.outerWidth();
            Gikam.selectPicker = new Vue({
                el: mountedDom,
                data() {
                    return {
                        search: _this.options.search || false,
                        value: "",
                        lists: _this.items
                    };
                },
                render() {
                    return (
                        <div
                            class="select-picker"
                            style={{
                                position: "absolute",
                                top: $top + "px",
                                left: $left + "px",
                                width: $width + "px"
                            }}
                            onmousedown={function(e) {
                                e.stopPropagation();
                            }}
                            onmousewheel={function(e) {
                                e.stopPropagation();
                            }}
                        >
                            <div>
                                {this.search && (
                                    <input
                                        type="text"
                                        value={this.value}
                                        placeholder="搜索"
                                        oninput={inputHandle}
                                    />
                                )}
                            </div>
                            <scroll
                                ops={{ scrollPanel: { scrollingX: false } }}
                            >
                                <ul>
                                    {this.lists.map(item => {
                                        return (
                                            <li
                                                class={{
                                                    "current-value":
                                                        item.value ===
                                                        _this.value
                                                }}
                                                value={item.value}
                                                onClick={selectHandle}
                                            >
                                                <div
                                                    class="text-ellipsis"
                                                    title={item.text}
                                                    domPropsInnerHTML={item.text}
                                                >
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </scroll>
                        </div>
                    );
                }
            });

            const $selectPicker = jQuery(Gikam.selectPicker.$el);
            $selectPicker.data("relate", _this);
            $selectPicker.height() > this.maxHeight &&
                $selectPicker.height(this.maxHeight);
        },

        setItems(items) {
            this.items = items;
        },

        dblclickHandle() {
            this.$emit("dblclick", this);
        },

        focus() {
            this.focusFlag = true;
        },

        clickHandle() {
            this.$emit("click", this);
        },

        getDefaultValue() {
            if (Gikam.isNotEmpty(this.options.selectedIndex)) {
                return this.options.items[this.options.selectedIndex].value;
            }
            if (Gikam.isNotEmpty(this.propValue)) {
                return this.propValue;
            }
            return this.options.value;
        }
    }
};
</script>
<style>
.select {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: stretch;
    padding: 0;
}

.select.readonly {
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.select .select-container,
.select .readonly-text {
    border: 1px solid #d9d9d9;
    display: flex;
    width: 100%;
    border-radius: 4px;
    cursor: pointer;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    background-color: #fff;
}

.select .readonly-text {
    background-color: #f4f4f4;
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 8px;
}

.select.validate-error .select-container {
    border-color: #ff6e6e;
}

.select .select-container .placeholder {
    width: 100%;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    padding-left: 14px;
    flex: 1;
}

.select .select-container .icon {
    width: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s;
}

.select.active .select-container {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.select.focus .select-container {
    border: 1px solid rgba(0, 122, 255, 0.5);
}

.select.active .select-container .icon {
    transform: rotate(180deg);
    color: #4784ff;
}

.select .select-container .text {
    width: calc(100% - 29px);
    flex: 1;
    padding-left: 8px;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    display: flex;
    align-items: center;
}

.select input {
    display: none;
}

.select-picker {
    margin-top: 1px;
    z-index: 11;
}

.select-picker input {
    width: calc(100% - 4px);
    height: 30px;
    border-radius: 4px;
    border: 1px solid #d9d9d9;
    padding-left: 8px;
    margin: 2px;
    margin-bottom: 0;
    color: rgba(0, 0, 0, 0.65);
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
}

.select-picker ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    background-color: white;
    min-height: 32px;
}

.select-picker ul li {
    height: 32px;
    font-family: "Microsoft YaHei", serif;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.65);
    display: flex;
    align-items: center;
    padding-left: 10px;
    cursor: pointer;
}

.select-picker ul li.current-value {
    color: #000;
}

.select-picker ul li:hover {
    background-color: rgba(0, 122, 255, 0.08);
}

.select-picker {
    z-index: 10;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.08);
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    overflow: hidden;
}

/* 字符串截取 xxx... */
.select-picker ul li .text-ellipsis,
.select .select-container .text .text-ellipsis {
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.text-ellipsis p {
    margin: 0;
}

.select.invisible .readonly-text {
    border: none;
    background-color: transparent;
}
</style>

